import * as service from './service';

export const allowedActionsStore = {
  service,
};
